import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import About from "./views/About.vue";
import Dashboard from "./views/Dashboard.vue";
import Login from "./views/Login.vue";
import store from "@/store";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/about",
      name: "about",
      component: About
    },
    {
      path: "/dashboard",
      name: "dashboard",
      component: Dashboard,
      meta: {
        needAuth: true
      }
    },
    {
      path: "/login",
      name: "login",
      component: Login,
      meta: {
        needAuth: false
      }
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.needAuth) {
    store
      .dispatch("login")
      .then(() => {
        next();
      })
      .catch(() => {
        next({
          path: "/login",
          params: {
            redirectPath: to.path
          }
        });
      });
  } else {
    next();
  }
});

export default router;
